<template>
    <div class="faq__item">
        <div class="wrapper">
            <div class="faq__controls">
                <div class="faq__close" v-bind:class="{'faq__close--show': open}" v-on:click="open = false">
                    <IconX></IconX>
                </div>
            </div>
            <div v-on:click="open = !open">
                <slot name="question"></slot>
            </div>

            <div class="faq__answer" v-bind:class="{'faq__answer--open': open}">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>
<script>
    import IconX from '../../images/icon-x.svg'

    export default {

        components: {
            IconX
        },

        data: function() {
            return {
                open: false
            }
        },

        methods: {

        }
    }
</script>


// WEBPACK FOOTER //
// FaqItem.vue?0dde70ec